<!-- ── Admin top bar ─────────────────────────────────────────────────────── -->
<div style="background:#0f172a;color:#f8fafc;padding:0;position:sticky;top:0;z-index:100;box-shadow:0 1px 3px rgba(0,0,0,.4);">
  <div style="display:flex;align-items:center;justify-content:space-between;height:52px;padding:0 16px;max-width:1400px;margin:0 auto;">
    <div style="display:flex;align-items:center;gap:4px;overflow-x:auto;scrollbar-width:none;flex:1;min-width:0;">
      <span style="font-size:13px;font-weight:700;letter-spacing:1px;color:#38bdf8;text-transform:uppercase;white-space:nowrap;flex-shrink:0;margin-right:8px;">TG Admin</span>
      <span style="width:1px;height:18px;background:#334155;flex-shrink:0;margin-right:4px;"></span>
      <a routerLink="/admin/scraper"   style="font-size:13px;color:#94a3b8;text-decoration:none;padding:6px 10px;border-radius:4px;white-space:nowrap;flex-shrink:0;" onmouseover="this.style.color='#f8fafc'" onmouseout="this.style.color='#94a3b8'">Scraper</a>
      <a routerLink="/admin/vacantes"  style="font-size:13px;color:#94a3b8;text-decoration:none;padding:6px 10px;border-radius:4px;white-space:nowrap;flex-shrink:0;" onmouseover="this.style.color='#f8fafc'" onmouseout="this.style.color='#94a3b8'">Vacantes</a>
      <a routerLink="/admin/usuarios"  style="font-size:13px;color:#94a3b8;text-decoration:none;padding:6px 10px;border-radius:4px;white-space:nowrap;flex-shrink:0;" onmouseover="this.style.color='#f8fafc'" onmouseout="this.style.color='#94a3b8'">Usuarios</a>
      <a routerLink="/admin/gurumatch" style="font-size:13px;color:#94a3b8;text-decoration:none;padding:6px 10px;border-radius:4px;white-space:nowrap;flex-shrink:0;" onmouseover="this.style.color='#f8fafc'" onmouseout="this.style.color='#94a3b8'">GuruMatch</a>
      <span style="font-size:13px;font-weight:600;color:#f8fafc;padding:6px 10px;background:#1e3a5f;border-radius:4px;white-space:nowrap;flex-shrink:0;">Suscripciones</span>
      <a routerLink="/admin/config"    style="font-size:13px;color:#94a3b8;text-decoration:none;padding:6px 10px;border-radius:4px;white-space:nowrap;flex-shrink:0;" onmouseover="this.style.color='#f8fafc'" onmouseout="this.style.color='#94a3b8'">Config</a>
      <a routerLink="/admin/social"    style="font-size:13px;color:#94a3b8;text-decoration:none;padding:6px 10px;border-radius:4px;white-space:nowrap;flex-shrink:0;" onmouseover="this.style.color='#f8fafc'" onmouseout="this.style.color='#94a3b8'">Redes Sociales</a>
    </div>
    <button (click)="cerrarSesion()" style="flex-shrink:0;margin-left:12px;display:inline-flex;align-items:center;gap:6px;background:#7f1d1d;color:#fca5a5;border:none;border-radius:6px;padding:6px 14px;font-size:12px;font-weight:600;cursor:pointer;white-space:nowrap;">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" style="width:13px;height:13px;flex-shrink:0;"><path stroke-linecap="round" stroke-linejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15M12 9l-3 3m0 0 3 3m-3-3h12.75"/></svg>
      Salir
    </button>
  </div>
</div>

<!-- ── Stats bar ─────────────────────────────────────────────────────────── -->
<div style="background:#1e293b;border-bottom:1px solid #334155;padding:14px 16px;">
  <div style="max-width:1400px;margin:0 auto;">
    <div style="display:flex;flex-wrap:wrap;gap:10px;">
      <div style="background:#0f172a;border:1px solid #334155;border-radius:10px;padding:12px 18px;min-width:110px;flex:1 1 110px;">
        <div style="font-size:10px;font-weight:700;color:#94a3b8;text-transform:uppercase;letter-spacing:.6px;margin-bottom:4px;">Gratis</div>
        <div style="font-size:24px;font-weight:700;color:#94a3b8;">{{ stats.free }}</div>
      </div>
      <div style="background:#0f172a;border:1px solid #334155;border-radius:10px;padding:12px 18px;min-width:110px;flex:1 1 110px;">
        <div style="font-size:10px;font-weight:700;color:#f59e0b;text-transform:uppercase;letter-spacing:.6px;margin-bottom:4px;">Premium</div>
        <div style="font-size:24px;font-weight:700;color:#f59e0b;">{{ stats.premium }}</div>
      </div>
      <div style="background:#0f172a;border:1px solid #334155;border-radius:10px;padding:12px 18px;min-width:110px;flex:1 1 110px;">
        <div style="font-size:10px;font-weight:700;color:#fb923c;text-transform:uppercase;letter-spacing:.6px;margin-bottom:4px;">Cancelando</div>
        <div style="font-size:24px;font-weight:700;color:#fb923c;">{{ stats.cancelando }}</div>
      </div>
      <div style="background:#0f172a;border:1px solid #334155;border-radius:10px;padding:12px 18px;min-width:110px;flex:1 1 110px;">
        <div style="font-size:10px;font-weight:700;color:#f87171;text-transform:uppercase;letter-spacing:.6px;margin-bottom:4px;">Cancelado</div>
        <div style="font-size:24px;font-weight:700;color:#f87171;">{{ stats.canceled }}</div>
      </div>
      <div style="background:#0f172a;border:1px solid #334155;border-radius:10px;padding:12px 18px;min-width:110px;flex:1 1 110px;">
        <div style="font-size:10px;font-weight:700;color:#60a5fa;text-transform:uppercase;letter-spacing:.6px;margin-bottom:4px;">Pagos</div>
        <div style="font-size:24px;font-weight:700;color:#60a5fa;">{{ stats.totalPagados }}</div>
      </div>
      <div style="background:#0f172a;border:1px solid #4ade80;border-radius:10px;padding:12px 18px;min-width:160px;flex:1 1 160px;">
        <div style="font-size:10px;font-weight:700;color:#4ade80;text-transform:uppercase;letter-spacing:.6px;margin-bottom:4px;">Ingresos totales</div>
        <div style="font-size:22px;font-weight:700;color:#4ade80;">${{ (stats.ingresoTotal ?? 0) | number:'1.2-2' }}</div>
      </div>
    </div>
  </div>
</div>

<!-- ── Main content ───────────────────────────────────────────────────────── -->
<div style="max-width:1400px;margin:0 auto;padding:20px 16px 60px;">

  <!-- ─ Filters + action row ─ -->
  <div style="display:flex;flex-wrap:wrap;gap:8px;align-items:flex-end;margin-bottom:16px;">
    <input type="text" [(ngModel)]="filtroNombre" (keydown.enter)="buscar()" placeholder="Nombre candidato"
           style="flex:1 1 160px;min-width:140px;padding:8px 12px;border:1px solid #e2e8f0;border-radius:6px;font-size:13px;background:#fff;color:#1e293b;outline:none;"
           (focus)="$event.target.style.borderColor='#38bdf8'" (blur)="$event.target.style.borderColor='#e2e8f0'"/>
    <input type="text" [(ngModel)]="filtroCorreo" (keydown.enter)="buscar()" placeholder="Correo"
           style="flex:1 1 160px;min-width:140px;padding:8px 12px;border:1px solid #e2e8f0;border-radius:6px;font-size:13px;background:#fff;color:#1e293b;outline:none;"
           (focus)="$event.target.style.borderColor='#38bdf8'" (blur)="$event.target.style.borderColor='#e2e8f0'"/>
    <select [(ngModel)]="filtroStatus" style="flex:1 1 130px;min-width:120px;padding:8px 10px;border:1px solid #e2e8f0;border-radius:6px;font-size:13px;background:#fff;color:#1e293b;">
      <option value="ALL">Todos los status</option>
      <option value="PAGADO">Pagado</option>
      <option value="PENDIENTE">Pendiente</option>
      <option value="FALLIDO">Fallido</option>
    </select>
    <select [(ngModel)]="filtroMetodo" style="flex:1 1 130px;min-width:120px;padding:8px 10px;border:1px solid #e2e8f0;border-radius:6px;font-size:13px;background:#fff;color:#1e293b;">
      <option value="ALL">Todos los métodos</option>
      <option value="STRIPE">Stripe</option>
      <option value="TRANSFERENCIA">Transferencia</option>
      <option value="EFECTIVO">Efectivo</option>
      <option value="OXXO">OXXO</option>
    </select>
    <div style="display:flex;align-items:center;gap:6px;flex:1 1 260px;min-width:240px;">
      <label style="font-size:12px;color:#64748b;white-space:nowrap;">Desde</label>
      <input type="date" [(ngModel)]="filtroDesde" style="flex:1;padding:8px 10px;border:1px solid #e2e8f0;border-radius:6px;font-size:13px;background:#fff;color:#1e293b;"/>
      <label style="font-size:12px;color:#64748b;white-space:nowrap;">Hasta</label>
      <input type="date" [(ngModel)]="filtroHasta" style="flex:1;padding:8px 10px;border:1px solid #e2e8f0;border-radius:6px;font-size:13px;background:#fff;color:#1e293b;"/>
    </div>
    <button (click)="buscar()" style="padding:8px 18px;background:#0ea5e9;color:#fff;border:none;border-radius:6px;font-size:13px;font-weight:600;cursor:pointer;white-space:nowrap;">Buscar</button>
    <button (click)="limpiarFiltros()" style="padding:8px 14px;background:#f1f5f9;color:#475569;border:1px solid #e2e8f0;border-radius:6px;font-size:13px;font-weight:600;cursor:pointer;white-space:nowrap;">Limpiar</button>
    <button (click)="abrirFormPago()" style="padding:8px 18px;background:#16a34a;color:#fff;border:none;border-radius:6px;font-size:13px;font-weight:600;cursor:pointer;white-space:nowrap;margin-left:auto;">+ Pago manual</button>
  </div>

  <!-- ─ Spinner ─ -->
  <div *ngIf="cargandoPagos" style="text-align:center;padding:60px 0;color:#64748b;font-size:14px;">Cargando pagos…</div>

  <!-- ─ Table ─ -->
  <div *ngIf="!cargandoPagos">
    <div style="overflow-x:auto;border-radius:10px;border:1px solid #e2e8f0;box-shadow:0 1px 4px rgba(0,0,0,.06);">
      <table style="width:100%;border-collapse:collapse;background:#fff;font-size:13px;">
        <thead>
          <tr style="background:#f8fafc;border-bottom:2px solid #e2e8f0;">
            <th style="padding:10px 14px;text-align:left;color:#475569;font-weight:600;white-space:nowrap;">Candidato</th>
            <th style="padding:10px 14px;text-align:left;color:#475569;font-weight:600;white-space:nowrap;">Plan</th>
            <th style="padding:10px 14px;text-align:right;color:#475569;font-weight:600;white-space:nowrap;">Monto</th>
            <th style="padding:10px 14px;text-align:left;color:#475569;font-weight:600;white-space:nowrap;">Fecha</th>
            <th style="padding:10px 14px;text-align:left;color:#475569;font-weight:600;white-space:nowrap;">Método</th>
            <th style="padding:10px 14px;text-align:left;color:#475569;font-weight:600;white-space:nowrap;">Status</th>
            <th style="padding:10px 14px;text-align:left;color:#475569;font-weight:600;white-space:nowrap;">Comprobante</th>
            <th style="padding:10px 14px;text-align:left;color:#475569;font-weight:600;white-space:nowrap;">Invoice / Notas</th>
            <th style="padding:10px 2px;text-align:center;color:#475569;font-weight:600;white-space:nowrap;"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let p of pagos"
              style="border-bottom:1px solid #f1f5f9;transition:background .15s;"
              onmouseover="this.style.background='#f8fafc'" onmouseout="this.style.background='#fff'">

            <!-- Candidato -->
            <td style="padding:10px 14px;min-width:180px;">
              <div style="font-weight:600;color:#1e293b;">{{ p.candidatoNombre || '—' }}</div>
              <div style="font-size:11px;color:#94a3b8;margin-top:2px;">{{ p.candidatoCorreo || '' }}</div>
            </td>

            <!-- Plan -->
            <td style="padding:10px 14px;white-space:nowrap;">
              <span *ngIf="p.planTipo"
                    [style.color]="planBadgeColor(p.planTipo)"
                    style="padding:3px 10px;border-radius:20px;font-size:11px;font-weight:700;background:rgba(0,0,0,.05);">
                {{ p.planTipo }}
              </span>
              <span *ngIf="!p.planTipo" style="color:#cbd5e1;font-size:12px;">—</span>
            </td>

            <!-- Monto -->
            <td style="padding:10px 14px;text-align:right;font-weight:700;color:#0f172a;white-space:nowrap;font-size:14px;">
              {{ formatMonto(p.monto, p.moneda) }}
            </td>

            <!-- Fecha -->
            <td style="padding:10px 14px;color:#64748b;font-size:12px;white-space:nowrap;">
              {{ p.fechaPago ? (p.fechaPago | appDate:'dd/MM/yyyy HH:mm') : '—' }}
            </td>

            <!-- Método -->
            <td style="padding:10px 14px;white-space:nowrap;">
              <span [style.background]="'rgba(0,0,0,.06)'" [style.color]="metodoBadgeColor(p.metodo)"
                    style="padding:3px 10px;border-radius:20px;font-size:11px;font-weight:700;letter-spacing:.4px;">
                {{ p.metodo || '—' }}
              </span>
            </td>

            <!-- Status -->
            <td style="padding:10px 14px;white-space:nowrap;">
              <span [style.color]="statusBadgeColor(p.statusPago)" [style.background]="'rgba(0,0,0,.05)'"
                    style="padding:3px 10px;border-radius:20px;font-size:11px;font-weight:700;">
                {{ p.statusPago || '—' }}
              </span>
            </td>

            <!-- Comprobante -->
            <td style="padding:10px 14px;white-space:nowrap;">
              <ng-container *ngIf="p.comprobanteUrl; else sinComprobante">
                <a [href]="p.comprobanteUrl" target="_blank"
                   style="display:inline-flex;align-items:center;gap:4px;font-size:12px;font-weight:600;color:#0ea5e9;text-decoration:none;padding:3px 8px;background:#f0f9ff;border:1px solid #bae6fd;border-radius:6px;"
                   onmouseover="this.style.background='#e0f2fe'" onmouseout="this.style.background='#f0f9ff'">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width:13px;height:13px;flex-shrink:0;"><path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m.75 12 3 3m0 0 3-3m-3 3v-6m-1.5-9H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9z"/></svg>
                  {{ p.comprobanteTipo === 'PDF' ? 'PDF' : 'Imagen' }}
                </a>
              </ng-container>
              <ng-template #sinComprobante>
                <span style="color:#cbd5e1;font-size:12px;">—</span>
              </ng-template>
            </td>

            <!-- Invoice / Notas -->
            <td style="padding:10px 14px;max-width:180px;">
              <ng-container *ngIf="p.stripeInvoiceId; else soloNotas">
                <a *ngIf="p.stripeReceiptUrl; else idSinLink"
                   [href]="p.stripeReceiptUrl" target="_blank"
                   style="font-family:monospace;font-size:11px;color:#818cf8;text-decoration:none;"
                   [title]="p.stripeInvoiceId">
                  {{ p.stripeInvoiceId | slice:0:16 }}…
                </a>
                <ng-template #idSinLink>
                  <span style="font-family:monospace;font-size:11px;color:#64748b;" [title]="p.stripeInvoiceId">{{ p.stripeInvoiceId | slice:0:16 }}…</span>
                </ng-template>
              </ng-container>
              <ng-template #soloNotas>
                <span style="font-size:12px;color:#64748b;display:block;max-width:180px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;" [title]="p.notas">{{ p.notas || '' }}</span>
              </ng-template>
            </td>

            <!-- Acción detalle -->
            <td style="padding:10px 8px;text-align:center;">
              <button (click)="verDetalle(p)"
                      style="background:#f1f5f9;border:1px solid #e2e8f0;color:#475569;border-radius:6px;padding:4px 8px;font-size:11px;cursor:pointer;white-space:nowrap;"
                      onmouseover="this.style.background='#e2e8f0'" onmouseout="this.style.background='#f1f5f9'">
                Ver más
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <p *ngIf="pagos.length === 0" style="text-align:center;color:#94a3b8;padding:48px 0;font-size:14px;">No se encontraron pagos con los filtros aplicados.</p>

    <!-- Paginación -->
    <div *ngIf="totalPagos > 0" style="display:flex;align-items:center;justify-content:space-between;margin-top:12px;flex-wrap:wrap;gap:8px;">
      <span style="font-size:12px;color:#64748b;">{{ paginaInicio }}–{{ paginaFin }} de {{ totalPagos }} pagos</span>
      <div style="display:flex;gap:6px;">
        <button (click)="paginaAnterior()" [disabled]="paginaActual === 0"
                style="padding:6px 14px;background:#f1f5f9;color:#475569;border:1px solid #e2e8f0;border-radius:6px;font-size:12px;font-weight:600;cursor:pointer;"
                [style.opacity]="paginaActual === 0 ? '0.4' : '1'">← Anterior</button>
        <button (click)="paginaSiguiente()" [disabled]="paginaFin >= totalPagos"
                style="padding:6px 14px;background:#f1f5f9;color:#475569;border:1px solid #e2e8f0;border-radius:6px;font-size:12px;font-weight:600;cursor:pointer;"
                [style.opacity]="paginaFin >= totalPagos ? '0.4' : '1'">Siguiente →</button>
      </div>
    </div>
  </div>
</div>

<!-- ══════════════════════════════════════════════════════════════════════════
     Modal: Nuevo pago manual
     ══════════════════════════════════════════════════════════════════════════ -->
<div *ngIf="mostrarFormPago"
     style="position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:200;display:flex;align-items:center;justify-content:center;padding:16px;"
     (click)="mostrarFormPago = false">

  <div style="background:#fff;border-radius:14px;width:100%;max-width:520px;max-height:90vh;overflow-y:auto;box-shadow:0 24px 64px rgba(0,0,0,.3);"
       (click)="$event.stopPropagation()">

    <!-- Header -->
    <div style="background:#0f172a;color:#f8fafc;padding:16px 20px;display:flex;align-items:center;justify-content:space-between;border-radius:14px 14px 0 0;">
      <span style="font-size:15px;font-weight:700;">Registrar pago manual</span>
      <button (click)="mostrarFormPago = false" style="background:none;border:none;color:#94a3b8;cursor:pointer;font-size:22px;line-height:1;padding:0 4px;">×</button>
    </div>

    <!-- Body -->
    <div style="padding:22px 24px;display:flex;flex-direction:column;gap:18px;">

      <!-- Error -->
      <div *ngIf="errorPago" style="background:#fef2f2;border:1px solid #fecaca;border-radius:8px;padding:10px 14px;font-size:13px;color:#dc2626;">
        {{ errorPago }}
      </div>

      <!-- 1. Buscador de candidato -->
      <div>
        <label style="font-size:12px;font-weight:700;color:#374151;display:block;margin-bottom:6px;">
          Candidato *
        </label>
        <div style="position:relative;">
          <input type="text" [(ngModel)]="busquedaTexto"
                 (ngModelChange)="onBusquedaCambio($event)"
                 placeholder="Buscar por nombre, apellido o correo…"
                 style="width:100%;padding:9px 36px 9px 12px;border:1px solid #d1d5db;border-radius:8px;font-size:13px;color:#1e293b;box-sizing:border-box;outline:none;"
                 (focus)="$event.target.style.borderColor='#0ea5e9'"
                 (blur)="$event.target.style.borderColor='#d1d5db'"/>
          <!-- spinner -->
          <span *ngIf="buscandoCandidatos"
                style="position:absolute;right:10px;top:50%;transform:translateY(-50%);font-size:12px;color:#94a3b8;">⟳</span>
          <!-- checkmark si ya seleccionó -->
          <span *ngIf="candidatoSeleccionado && !buscandoCandidatos"
                style="position:absolute;right:10px;top:50%;transform:translateY(-50%);color:#16a34a;font-size:16px;">✓</span>
        </div>

        <!-- Dropdown resultados -->
        <div *ngIf="resultadosBusqueda.length > 0"
             style="background:#fff;border:1px solid #e2e8f0;border-radius:8px;box-shadow:0 8px 24px rgba(0,0,0,.12);margin-top:4px;overflow:hidden;">
          <div *ngFor="let c of resultadosBusqueda"
               (click)="seleccionarCandidato(c)"
               style="padding:10px 14px;cursor:pointer;border-bottom:1px solid #f1f5f9;display:flex;align-items:flex-start;justify-content:space-between;gap:8px;"
               onmouseover="this.style.background='#f0f9ff'" onmouseout="this.style.background='#fff'">
            <div>
              <div style="font-size:13px;font-weight:600;color:#1e293b;">{{ c.nombre }}</div>
              <div style="font-size:11px;color:#94a3b8;margin-top:1px;">{{ c.correo }}</div>
            </div>
            <span [style.color]="c.status === 'PREMIUM' || c.status === 'CANCELANDO' ? '#16a34a' : '#94a3b8'"
                  style="font-size:10px;font-weight:700;white-space:nowrap;padding:2px 7px;background:rgba(0,0,0,.05);border-radius:10px;">
              {{ c.status }}
            </span>
          </div>
          <div *ngIf="resultadosBusqueda.length === 0 && !buscandoCandidatos && busquedaTexto.length >= 2"
               style="padding:10px 14px;font-size:12px;color:#94a3b8;">Sin resultados</div>
        </div>

        <!-- Chip candidato seleccionado -->
        <div *ngIf="candidatoSeleccionado"
             style="margin-top:8px;background:#f0fdf4;border:1px solid #bbf7d0;border-radius:8px;padding:8px 12px;display:flex;align-items:center;justify-content:space-between;">
          <div>
            <span style="font-size:13px;font-weight:600;color:#166534;">{{ candidatoSeleccionado.nombre }}</span>
            <span style="font-size:11px;color:#16a34a;margin-left:8px;">{{ candidatoSeleccionado.correo }}</span>
          </div>
          <button (click)="candidatoSeleccionado = null; busquedaTexto = ''"
                  style="background:none;border:none;color:#94a3b8;cursor:pointer;font-size:16px;line-height:1;padding:0 2px;">×</button>
        </div>
      </div>

      <!-- 2. Tipo de suscripción -->
      <div>
        <label style="font-size:12px;font-weight:700;color:#374151;display:block;margin-bottom:6px;">
          Tipo de suscripción *
        </label>
        <div style="display:flex;gap:8px;">
          <button (click)="planTipo='MENSUAL'; onPlanCambio()"
                  [style.background]="planTipo==='MENSUAL' ? '#1d4ed8' : '#f1f5f9'"
                  [style.color]="planTipo==='MENSUAL' ? '#fff' : '#475569'"
                  [style.border]="planTipo==='MENSUAL' ? '2px solid #1d4ed8' : '2px solid #e2e8f0'"
                  style="flex:1;padding:10px;border-radius:8px;font-size:13px;font-weight:600;cursor:pointer;transition:.15s;">
            Mensual
          </button>
          <button (click)="planTipo='ANUAL'; onPlanCambio()"
                  [style.background]="planTipo==='ANUAL' ? '#1d4ed8' : '#f1f5f9'"
                  [style.color]="planTipo==='ANUAL' ? '#fff' : '#475569'"
                  [style.border]="planTipo==='ANUAL' ? '2px solid #1d4ed8' : '2px solid #e2e8f0'"
                  style="flex:1;padding:10px;border-radius:8px;font-size:13px;font-weight:600;cursor:pointer;transition:.15s;">
            Anual
          </button>
        </div>
        <p style="font-size:11px;color:#94a3b8;margin:6px 0 0;">
          Premium activo {{ planTipo === 'ANUAL' ? '365 días' : '30 días' }} a partir de hoy.
        </p>
      </div>

      <!-- 3. Monto + moneda -->
      <div style="display:flex;gap:10px;">
        <div style="flex:2;">
          <label style="font-size:12px;font-weight:700;color:#374151;display:block;margin-bottom:6px;">Monto *</label>
          <input type="number" step="0.01" min="0" [(ngModel)]="monto" placeholder="0.00"
                 style="width:100%;padding:9px 12px;border:1px solid #d1d5db;border-radius:8px;font-size:14px;font-weight:600;color:#1e293b;box-sizing:border-box;outline:none;"
                 (focus)="$event.target.style.borderColor='#0ea5e9'"
                 (blur)="$event.target.style.borderColor='#d1d5db'"/>
          <p style="font-size:11px;color:#94a3b8;margin:4px 0 0;">Precio sugerido pre-llenado, editable.</p>
        </div>
        <div style="flex:1;">
          <label style="font-size:12px;font-weight:700;color:#374151;display:block;margin-bottom:6px;">Moneda</label>
          <select [(ngModel)]="moneda" (ngModelChange)="onMonedaCambio()"
                  style="width:100%;padding:9px 10px;border:1px solid #d1d5db;border-radius:8px;font-size:13px;background:#fff;color:#1e293b;outline:none;">
            <option *ngFor="let m of monedas" [value]="m">{{ m }}</option>
          </select>
        </div>
      </div>

      <!-- 4. Método de pago -->
      <div>
        <label style="font-size:12px;font-weight:700;color:#374151;display:block;margin-bottom:6px;">Método de pago</label>
        <select [(ngModel)]="metodo"
                style="width:100%;padding:9px 10px;border:1px solid #d1d5db;border-radius:8px;font-size:13px;background:#fff;color:#1e293b;outline:none;">
          <option *ngFor="let m of metodos" [value]="m.value">{{ m.label }}</option>
        </select>
      </div>

      <!-- 5. Comprobante de pago -->
      <div>
        <label style="font-size:12px;font-weight:700;color:#374151;display:block;margin-bottom:6px;">
          Comprobante de pago <span style="font-weight:400;color:#94a3b8;">(opcional · PDF o imagen)</span>
        </label>
        <label style="display:flex;align-items:center;gap:10px;padding:10px 14px;border:1px dashed #d1d5db;border-radius:8px;cursor:pointer;background:#fafafa;transition:.15s;"
               onmouseover="this.style.borderColor='#0ea5e9';this.style.background='#f0f9ff'"
               onmouseout="this.style.borderColor='#d1d5db';this.style.background='#fafafa'">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#94a3b8" style="width:20px;height:20px;flex-shrink:0;"><path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5"/></svg>
          <span style="font-size:13px;color:#64748b;">
            {{ comprobanteNombre || 'Seleccionar archivo…' }}
          </span>
          <input type="file" accept="image/*,.pdf" (change)="onArchivoSeleccionado($event)" style="display:none;"/>
        </label>
        <div *ngIf="comprobanteFile"
             style="margin-top:6px;font-size:11px;color:#16a34a;display:flex;align-items:center;gap:4px;">
          <span>✓</span> {{ comprobanteNombre }} ({{ (comprobanteFile.size / 1024).toFixed(0) }} KB)
        </div>
      </div>

      <!-- 6. Notas -->
      <div>
        <label style="font-size:12px;font-weight:700;color:#374151;display:block;margin-bottom:6px;">Notas</label>
        <textarea [(ngModel)]="notas" rows="2" placeholder="Referencia de transferencia, número de folio, observaciones…"
                  style="width:100%;padding:9px 12px;border:1px solid #d1d5db;border-radius:8px;font-size:13px;color:#1e293b;resize:vertical;box-sizing:border-box;font-family:inherit;outline:none;"
                  (focus)="$event.target.style.borderColor='#0ea5e9'"
                  (blur)="$event.target.style.borderColor='#d1d5db'"></textarea>
      </div>

    </div><!-- /body -->

    <!-- Footer -->
    <div style="padding:16px 24px;border-top:1px solid #f1f5f9;display:flex;gap:10px;justify-content:flex-end;background:#fafafa;border-radius:0 0 14px 14px;">
      <button (click)="mostrarFormPago = false"
              style="padding:10px 22px;background:#f1f5f9;color:#475569;border:1px solid #e2e8f0;border-radius:8px;font-size:13px;font-weight:600;cursor:pointer;">
        Cancelar
      </button>
      <button (click)="guardarPagoManual()" [disabled]="guardandoPago || !formularioValido"
              style="padding:10px 22px;background:#16a34a;color:#fff;border:none;border-radius:8px;font-size:13px;font-weight:600;cursor:pointer;transition:.15s;"
              [style.opacity]="(guardandoPago || !formularioValido) ? '0.5' : '1'">
        {{ guardandoPago ? 'Guardando…' : 'Activar Premium y guardar' }}
      </button>
    </div>

  </div>
</div>

<!-- ══════════════════════════════════════════════════════════════════════════
     Modal: Detalle de pago
     ══════════════════════════════════════════════════════════════════════════ -->
<div *ngIf="pagoDetalle"
     style="position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:200;display:flex;align-items:center;justify-content:center;padding:16px;"
     (click)="cerrarDetalle()">

  <div style="background:#fff;border-radius:14px;width:100%;max-width:480px;box-shadow:0 24px 64px rgba(0,0,0,.3);"
       (click)="$event.stopPropagation()">

    <div style="background:#0f172a;color:#f8fafc;padding:16px 20px;display:flex;align-items:center;justify-content:space-between;border-radius:14px 14px 0 0;">
      <span style="font-size:15px;font-weight:700;">Detalle de pago</span>
      <button (click)="cerrarDetalle()" style="background:none;border:none;color:#94a3b8;cursor:pointer;font-size:22px;line-height:1;padding:0 4px;">×</button>
    </div>

    <div style="padding:22px 24px;display:flex;flex-direction:column;gap:12px;font-size:13px;">
      <div style="display:flex;justify-content:space-between;"><span style="color:#94a3b8;">Candidato</span><strong>{{ pagoDetalle.candidatoNombre }}</strong></div>
      <div style="display:flex;justify-content:space-between;"><span style="color:#94a3b8;">Correo</span><span>{{ pagoDetalle.candidatoCorreo }}</span></div>
      <div style="display:flex;justify-content:space-between;"><span style="color:#94a3b8;">Plan</span>
        <span [style.color]="planBadgeColor(pagoDetalle.planTipo)" style="font-weight:700;">{{ pagoDetalle.planTipo || '—' }}</span>
      </div>
      <div style="display:flex;justify-content:space-between;"><span style="color:#94a3b8;">Monto</span><strong>{{ formatMonto(pagoDetalle.monto, pagoDetalle.moneda) }}</strong></div>
      <div style="display:flex;justify-content:space-between;"><span style="color:#94a3b8;">Fecha de pago</span><span>{{ pagoDetalle.fechaPago | appDate:'dd/MM/yyyy HH:mm' }}</span></div>
      <div style="display:flex;justify-content:space-between;"><span style="color:#94a3b8;">Método</span><span>{{ pagoDetalle.metodo }}</span></div>
      <div style="display:flex;justify-content:space-between;"><span style="color:#94a3b8;">Status</span>
        <span [style.color]="statusBadgeColor(pagoDetalle.statusPago)" style="font-weight:700;">{{ pagoDetalle.statusPago }}</span>
      </div>
      <div *ngIf="pagoDetalle.notas" style="display:flex;flex-direction:column;gap:4px;"><span style="color:#94a3b8;">Notas</span><span style="color:#475569;">{{ pagoDetalle.notas }}</span></div>
      <div *ngIf="pagoDetalle.stripeInvoiceId">
        <span style="color:#94a3b8;">Invoice Stripe</span>
        <span style="font-family:monospace;font-size:11px;color:#818cf8;margin-left:8px;">{{ pagoDetalle.stripeInvoiceId }}</span>
      </div>
      <!-- Comprobante -->
      <div *ngIf="pagoDetalle.comprobanteUrl" style="border-top:1px solid #f1f5f9;padding-top:12px;">
        <div style="font-size:12px;font-weight:700;color:#374151;margin-bottom:8px;">Comprobante de pago</div>
        <a [href]="pagoDetalle.comprobanteUrl" target="_blank"
           style="display:inline-flex;align-items:center;gap:6px;padding:8px 16px;background:#f0f9ff;border:1px solid #bae6fd;border-radius:8px;color:#0ea5e9;font-size:13px;font-weight:600;text-decoration:none;">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width:16px;height:16px;"><path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"/></svg>
          Ver comprobante ({{ pagoDetalle.comprobanteTipo }})
        </a>
        <!-- Preview si es imagen -->
        <div *ngIf="pagoDetalle.comprobanteTipo === 'IMAGE'" style="margin-top:10px;border:1px solid #e2e8f0;border-radius:8px;overflow:hidden;max-height:200px;">
          <img [src]="pagoDetalle.comprobanteUrl" alt="comprobante" style="width:100%;object-fit:contain;max-height:200px;display:block;"/>
        </div>
      </div>
    </div>

    <div style="padding:14px 24px;border-top:1px solid #f1f5f9;display:flex;justify-content:flex-end;background:#fafafa;border-radius:0 0 14px 14px;">
      <button (click)="cerrarDetalle()" style="padding:8px 22px;background:#f1f5f9;color:#475569;border:1px solid #e2e8f0;border-radius:8px;font-size:13px;font-weight:600;cursor:pointer;">Cerrar</button>
    </div>
  </div>
</div>
